module.exports = __webpack_public_path__ + "img/sdmsolucion.d23524dd.png";